import BelepesForm from "../components/BelepesForm";

function Belepes() {
  return <BelepesForm />;
}

export default Belepes;
